import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { PaginationState } from './pagination-model';
import { createNewBook } from './pagination-slice';

export function usePagination(name: string, totalPages: number, currentPage: number) {
    const dispatch = useDispatch();
    const paginationState = useSelector<TcsmStates, PaginationState>(state => state.paginationState);
	const book = paginationState?.books[name];
	useEffect(() => {
		if (!book && name && totalPages && currentPage) {
			dispatch(createNewBook(name, totalPages, currentPage));
		}
	}, [name, totalPages, currentPage]);

	return book ?? undefined;
}
